$(document).ready(function() {

    $('.edgetoedgeblockmodel').each(function() {
        $('.edgetoedgeblockmodel').parent().attr("style", "margin-left: 0px !important; margin-right: 0px !important");
    });
});